[
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "envelopeRegistry_",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "deploymentChainId_",
				"type": "uint256"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"inputs": [],
		"name": "EnvelopeRecalled",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "ExceedsMaxCommitments",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "FileNotRegistered",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "InvalidPayer",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "InvalidReleaseConfig",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "ReentrancyGuardReentrantCall",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "RequiredSigningStarted",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "RuleAlreadyCancelled",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "RuleAlreadyExecuted",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "RuleNotExecutable",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "UnauthorizedRegistry",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "UnauthorizedRuleCancellation",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "UnauthorizedRuleRegistration",
		"type": "error"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "cidId",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes20",
				"name": "recipientsCommitment",
				"type": "bytes20"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "packetContentHash",
				"type": "bytes32"
			}
		],
		"name": "AttachmentReleased",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "cidId",
				"type": "bytes32"
			}
		],
		"name": "AttachmentRuleCancelled",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "cidId",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "bytes20",
				"name": "recipientsCommitment",
				"type": "bytes20"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "packetContentHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "enum FSAttachmentRelease.ReleaseType",
				"name": "releaseType",
				"type": "uint8"
			}
		],
		"name": "AttachmentRuleRegistered",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "cidId",
				"type": "bytes32"
			}
		],
		"name": "AttachmentRuleUpdated",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "cidId",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "oldCommitment",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "newCommitment",
				"type": "bytes32"
			}
		],
		"name": "SignerCommitmentRemapped",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			}
		],
		"name": "canRelease",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			}
		],
		"name": "cancelAttachmentRule",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "deploymentChainId",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "envelopeRegistry",
		"outputs": [
			{
				"internalType": "contract IFSEnvelopeRegistry",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			}
		],
		"name": "executeAttachmentRelease",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "nextRuleId",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "cidId_",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "packetContentHash_",
				"type": "bytes32"
			},
			{
				"internalType": "enum FSAttachmentRelease.ReleaseType",
				"name": "releaseType_",
				"type": "uint8"
			},
			{
				"internalType": "bytes32",
				"name": "specificSignerCommitment_",
				"type": "bytes32"
			},
			{
				"internalType": "uint8",
				"name": "thresholdN_",
				"type": "uint8"
			},
			{
				"internalType": "uint64",
				"name": "expiresAt_",
				"type": "uint64"
			},
			{
				"internalType": "bytes32[]",
				"name": "signerCommitments_",
				"type": "bytes32[]"
			},
			{
				"internalType": "bytes32[]",
				"name": "recipientEmailCommitments_",
				"type": "bytes32[]"
			}
		],
		"name": "registerAttachmentRule",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "cidId_",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "oldCommitment_",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "newCommitment_",
				"type": "bytes32"
			}
		],
		"name": "remapSignerCommitment",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "cidId_",
				"type": "bytes32"
			}
		],
		"name": "ruleIdsForCid",
		"outputs": [
			{
				"internalType": "uint256[]",
				"name": "",
				"type": "uint256[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			}
		],
		"name": "rules",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "cidId",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "bytes32",
				"name": "packetContentHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes20",
				"name": "recipientsCommitment",
				"type": "bytes20"
			},
			{
				"internalType": "enum FSAttachmentRelease.ReleaseType",
				"name": "releaseType",
				"type": "uint8"
			},
			{
				"internalType": "bytes32",
				"name": "specificSignerCommitment",
				"type": "bytes32"
			},
			{
				"internalType": "uint8",
				"name": "thresholdN",
				"type": "uint8"
			},
			{
				"internalType": "uint64",
				"name": "expiresAt",
				"type": "uint64"
			},
			{
				"internalType": "bool",
				"name": "released",
				"type": "bool"
			},
			{
				"internalType": "bool",
				"name": "cancelled",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			}
		],
		"name": "signerCommitments",
		"outputs": [
			{
				"internalType": "bytes32[]",
				"name": "",
				"type": "bytes32[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ruleId",
				"type": "uint256"
			},
			{
				"internalType": "bytes32",
				"name": "packetContentHash_",
				"type": "bytes32"
			},
			{
				"internalType": "enum FSAttachmentRelease.ReleaseType",
				"name": "releaseType_",
				"type": "uint8"
			},
			{
				"internalType": "bytes32",
				"name": "specificSignerCommitment_",
				"type": "bytes32"
			},
			{
				"internalType": "uint8",
				"name": "thresholdN_",
				"type": "uint8"
			},
			{
				"internalType": "uint64",
				"name": "expiresAt_",
				"type": "uint64"
			},
			{
				"internalType": "bytes32[]",
				"name": "signerCommitments_",
				"type": "bytes32[]"
			},
			{
				"internalType": "bytes32[]",
				"name": "recipientEmailCommitments_",
				"type": "bytes32[]"
			}
		],
		"name": "updateAttachmentRule",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
]
